export default ($) => {
    
	$(document).ready(function(){
		$(".blog-filter a.toggler").click(function(){
			$(this).toggleClass("collapsed");
			$("#collapseFilter").toggleClass("show");
		});
	});
	
	$( document ).ready(function() {
		
		if ($(window).width() > 767){
			
			var $sticky = $('.make-me-sticky');
			var $stickyrStopper = $('.prefooter');
			if (!!$sticky.offset()) { // make sure ".sticky" element exists

				var generalSidebarHeight = $sticky.innerHeight();
				var stickyTop = $sticky.offset().top;
				var stickOffset = 100;
				var stickyStopperPosition = $stickyrStopper.offset().top;
				var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset;
				var diff = stopPoint + stickOffset;

				$(window).scroll(function(){ // scroll event
					var windowTop = $(window).scrollTop(); // returns number

					if (stopPoint < windowTop) {
					  $sticky.css({ position: 'absolute', top: diff });
					} else if (stickyTop < windowTop+stickOffset) {
					  if ($(window).width() > 991){
					    $sticky.css({ position: 'fixed', top: stickOffset, float:'left', width: '160px'});
					  } else {
						$sticky.css({ position: 'fixed', top: stickOffset, float:'left', width: '96px'});
					  }
					  document.getElementById("prefooter").style.marginTop = "150px";
					} else {
					  $sticky.css({position: 'relative', top: 'initial', display:'unset'});
					}
				});

			}
		}
	});


}
